module.exports = __webpack_public_path__ + "img/sidebar-battery-7.6a84bd22.svg";